import { ChangeDetectionStrategy, Component, computed, input, output, ViewEncapsulation } from '@angular/core';
import { adaptEchartsOptions, BaseEchartsDirective } from '@examdojo/core/widget';
import { EChartsOption } from 'echarts';
import { BarChart, GraphChart, LineChart, ScatterChart, TreeChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  MarkLineComponent,
  MarkPointComponent,
  TooltipComponent,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { NgxEchartsDirective, provideEchartsCore } from 'ngx-echarts';

echarts.use([
  BarChart,
  GraphChart,
  LineChart,
  ScatterChart,
  TreeChart,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  MarkLineComponent,
  MarkPointComponent,
]);

@Component({
  selector: 'dojo-echarts-chart',
  standalone: true,
  imports: [NgxEchartsDirective],
  template: `<div
    echarts
    class="echarts-chart"
    [options]="adaptedOptions()"
    [initOpts]="initOpts"
    [autoResize]="true"
    (chartInit)="chartInit.emit($event)"
  ></div>`,
  styleUrl: './echarts-chart.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  providers: [provideEchartsCore({ echarts })],
})
export class EchartsChartComponent extends BaseEchartsDirective {
  readonly options = input<EChartsOption>({});
  readonly chartInit = output<unknown>();

  readonly adaptedOptions = computed(() => adaptEchartsOptions(this.options(), this.document, this.isDark()));
}
